import { get } from 'lodash';
import { createSelector } from 'reselect';
import addDays from 'date-fns/add_days';
import isAfter from 'date-fns/is_after';
import { getUnitViewPixel } from '@sparefoot/react-core/utils/tracking';

import { getFacilityFromRoute } from './facility';
import { getRecaptchaSiteKey } from './application';

export const getUnitFromRoute = createSelector(
	(state, props) => get(props, 'match.params.unitId'),
	(state) => state.units.byId,
	(unitId, units) => units[unitId],
);

export const UnitReservationFormSelector = createSelector(
	getRecaptchaSiteKey,
	(recaptchaSiteKey) => ({ recaptchaSiteKey }),
);

export default createSelector(
	getFacilityFromRoute,
	getUnitFromRoute,
	(state) => state.units.statusCode,
	(state) => state.units.loading,
	(state) => get(state.search, 'query.moveInDate'),
	(state) => state.app.baseUrl,

	(facility, unit, statusCode, loading, moveInDate, baseUrl) => ({
		facility,
		unit,
		statusCode,
		loading,
		meta: { ...get(unit, 'meta', {}), canonical: baseUrl + unit?.url },
		outsideReservationWindow: isAfter(
			moveInDate,
			addDays(new Date(), get(unit, 'reservationWindow')),
		),
		phone: get(facility, 'phone'),
		trackingPixel: getUnitViewPixel(get(unit, 'id'), get(facility, 'id')),
	}),
);
